import { graphql, Link, useStaticQuery } from "gatsby";
import React from "react";

import { Element, Image } from "components/shared/base";
import FooterLinks from "./FooterLinks";
import FooterContactInfo from "./FooterContactInfo";
import { PrismicFooterDataFooterLinkList } from "types/__generated__/gatsby-graphql";

const Footer: React.FC = (): React.ReactElement | null => {
  const footerData = useStaticQuery(graphql`
    query FooterQuery {
      prismicFooter {
        data {
          footer_link_list {
            link_text
            link_url {
              id
              url
              slug
              type
            }
          }
          contact_us_link {
            type
            link_type
            url
          }
          contact_us_text
          signature
          footer_logo {
            alt
            copyright
            url
            gatsbyImageData
          }
        }
      }
    }
  `);

  if (!footerData.prismicFooter || !footerData.prismicFooter.data) {
    return null;
  }

  const {
    contact_us_link,
    contact_us_text,
    footer_link_list,
    footer_logo,
    signature,
  } = footerData.prismicFooter.data;

  return (
    <Element
      as="footer"
      borderTopColor="black"
      borderTopStyle="solid"
      borderTopWidth="1px"
      color="textFooter"
      fontFamily="karla"
      mt={["35px", "70px"]}
      p={["35px 20px", "80px 20px"]}
    >
      <Element
        display="grid"
        fontSize={["text.footerMobile", "text.footer"]}
        gridColumnGap="20px"
        gridTemplateColumns={["repeat(12, 1fr)"]}
        lineHeight="primary"
        m="0 auto"
        maxWidth="contentWidth"
      >
        <Element
          gridColumnEnd={["span 12", "span 3", "span 5", "span 7"]}
          mb={["25px", "0"]}
          width="100%"
        >
          <Link to="/">
            {footer_logo && (
              <Image
                alt={footer_logo.alt}
                image={footer_logo.gatsbyImageData}
                maxwidth={["footerIconMobile", "footerIconDesktop"]}
                width="auto"
              />
            )}
          </Link>
        </Element>
        <Element
          as="ul"
          display={["grid", "block"]}
          gridColumnEnd={["span 12", "span 3", "span 2"]}
          gridTemplateColumns={["6fr 6fr", "auto"]}
        >
          {footer_link_list?.map((item: PrismicFooterDataFooterLinkList) => {
            const linkUrl = item?.link_url?.slug && `/${item?.link_url?.slug}`;
            const linkText = item?.link_text;
            const linkId = item?.link_url?.id;

            if (!linkUrl || !linkText) {
              return null;
            }

            return <FooterLinks href={linkUrl} text={linkText} key={linkId} />;
          })}
        </Element>
        <FooterContactInfo
          contact_us_link={contact_us_link}
          contact_us_text={contact_us_text}
          signature={signature}
        />
      </Element>
    </Element>
  );
};

export default Footer;
